import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuctionService } from 'src/app/services/auction.service';
import { ValidatorUtils } from 'src/app/utils/validator.utils';

@Component({
  selector: 'app-popup-super-bids',
  templateUrl: './popup-super-bids.component.html',
  styleUrls: ['./popup-super-bids.component.scss']
})
export class PopupSuperBidsComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<PopupSuperBidsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auctionService: AuctionService,
  ) {}

  loading = true;
  phase = 1;
  titleOnline = 'Super Lance';
  validator = new ValidatorUtils();

  socket = new WebSocket('wss://socket.wvleiloes.com/');

  ngOnInit(): void {
    this.loading = false;
  }

  nextPhase() {
    if (this.phase === 3) {
      this.finish();
    } else if (this.phase < 5) {
      this.phase++;

      if (this.phase === 3) {
        this.titleOnline = 'Finalizar Lance';
      } else if (this.phase === 4) {
        this.titleOnline = 'Parabéns!';
      }
    }
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: chance, results });
  }

  convertMoney(money: any) {
    return this.validator.convertMoney(money);
  }

  finish() {
    if (this.loading) return;

    this.loading = true;
    this.auctionService
      .createSuperBid(this.data.animal_obj.id)
      .subscribe(
        (data) => {
          this.phase++;
          this.titleOnline = 'Parabéns!';
          this.socket.send('SUPER_LANCE');
          this.loading = false;

          this.chance('yes')
        },
        (error) => {
          this.loading = false;
          console.error(error);
        }
      );
  }

}
